import multiplexing from './images/multiplexing.png';
import csma from './images/csma-cd-exp-back.png';
import flutterList from './images/flutter-list.png';
import flutterTheme from './images/flutter-theme.png';
import flutterData from './images/flutter-data.png';
import arcade from './images/arcade.png';
import seliger from './images/seliger.png';
import egaming from './images/e-gaming.png';

export const developmentVideoTitle = [
	{
		eyebrow: 'Videos',
		title: 'Flutter Apps and Computer Networking'
	}
]

export const managmentVideoTitle = [
	{
		eyebrow: 'Videos',
		title: 'Project Managment'
	}
]

export const developmentVideoData = [

	{
		title: 'Multiplexing and Demultiplexing',
		thumbnailText: 'An explanation of how computer applications communicate.',
		image: multiplexing,
		text: 'An outline of communication between computer applications through data segments wrapped into packets.',
		video: 'https://www.youtube.com/embed/hInRlX1NhWI'
	},
	{
		title: 'CSMA/CD Exponencial Backoff',
		thumbnailText: 'A tutorial of network concepts previously used for ethernet.',
		image: csma,
		text: 'How early ethernet networks detected and corrected data collisions, including how exponential backoff is calculated.',
		video: 'https://www.youtube.com/embed/j9TAGdwHwDI'
	},
	{
		title: 'Flutter: List and Styling',
		thumbnailText: 'Updating styles in a Flutter app.',
		image: flutterList,
		text: 'How styles in a simple Flutter application can be updated.',
		video: 'https://www.youtube.com/embed/LJBpNmAIDGI'
	},
	{
		title: 'Flutter: Database, State, Day/Night Theme',
		thumbnailText: 'Database integration and state in a Flutter app.',
		image: flutterTheme,
		text: 'Demonstration of a Flutter application that stores list enteries in a database, and remembers style settings after being closed and reopened.',
		video: 'https://www.youtube.com/embed/ZWV2BlNPxZg',
	},
	{
		title: 'Flutter: Saving Data',
		thumbnailText: 'Database and 3rd party application integration.',
		image: flutterData,
		text: 'Demonstration of a Flutter application that interacts with a phone’s camera to store pictures and text to an external database.',
		video: 'https://www.youtube.com/embed/q3Ry0N_nF4M',
	},
]

export const managmentVideoDataTest = [
	{
		title: 'SAAM Arcade',
		thumbnailText: 'Created record breaking event at Smithsonian American Art Museum.',
		image: arcade,
		text: 'While working at the Smithsonian American Art Museum, I created SAAM Arcade in partnership with American University, MAGFest, and the Entertainment Software Association. SAAM Arcade featured over 100 video games ranging from student games, and indies, to arcade classics. In 2017, the arcade lasted a full weekend, featuring an E-Sports tournament with the DC Boys and Girls Club, game building workshops, concerts, and more. 20,000 people attended the arcade making it the museum\'s most popular event to date.',
		video: 'https://www.youtube.com/embed/lyOE7SZn39g',
	},
	{
		title: 'E-Gaming with the Bodys and Girls Club',
		thumbnailText: 'Hosted tournament with Boys & Girls Club.',
		image: egaming,
		text: 'Events DC partnered with the Boys & Girls Club of Greater Washington, the Boys & Girls Club of Annapolis, and NRG Esports to host the first Youth Esports League Championship. Participating youth from both Boys & Girls Clubs competed in a six-week single elimination bracket-style tournament featuring Madden NFL 17 and NBA 2K17, which culminated for the championship on August 5 at the Smithsonian American Art Museum’s “SAAM Arcade” event. The Greater Washington Club won the championship in Madden NFL 17, while the Annapolis Club won in NBA 2k17. Viewers were treated to play-by-play commentating from Mega Ran and NRG Esports’ Nairo.',
		video: 'https://www.youtube.com/embed/CkJ4xe7aRj8',
	},
	{
		title: 'Photo DC: Mark Seliger',
		thumbnailText: 'Partnered with PhotoDC to bring famous photographers to the Smithsonian American Art Museum.',
		image: seliger,
		text: 'I created a lecture series in partnership with PhotoDC and the Smithsonian American Art Museum that brought famous photographers like Mary Ellen Mark and Mark Seliger to the American Art Museum to discuss their work.',
		video: 'https://www.youtube.com/embed/ud9XGZp3WQw',
	},
]